import axios from 'axios';
import { Category, CategoryWithQuestions, Question } from './helpDesk.types';

export const getSupportCategoriesAsync = async () => {
  const { data } = await axios.get(`/support/category`);
  return data.data.categories as Category[];
};

export const getCategoryWithQuestionAsync = async (id: string) => {
  const { data } = await axios.get(`/support/category/${id}`);
  return data.data.category as CategoryWithQuestions;
};

export const getQuestionAsync = async (id: string) => {
  const { data } = await axios.get(`/support/question/${id}`);
  return data.data.question as Question;
};

export const searchQuestionAsync = async (search: string) => {
  const { data } = await axios.get(`/support/question`, {
    params: { search }
  });
  return data.data.questions as Question[];
};
